import React, { useEffect, useState } from "react";
import "./form.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import axios from "axios";
import Col from "react-bootstrap/Col";
import WarningModal from "../modal";
import SubmitModal from "../submitmodal";
import Config from "../../config";
import CountryList from "../../assets/contryList.json";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";

function RegForm({ configData }) {
  const options = Array.from(
    {
      length:
        configData && configData.max_team_size
          ? configData.max_team_size
          : Config?.maxTeamSize,
    },
    (_, i) => i + 1
  );
  const [count, setCount] = useState(1);
  const [formFileds, setFormfieds] = useState([]);
  const [checked, setChecked] = useState(false);
  const [formData, setFormData] = useState({
    company: "",
    team_name: "",
    country: "",
    team_size: 1,
    primary_member: {
      first_name: "",
      last_name: "",
      email: "",
      job_title: "",
      phone: "",
    },
  });
  const [openSubmitModal, setopenSubmitModal] = useState(false);
  const [isMemberDetailsChanged, setIsMemberDetailsChanged] = useState(false);
  const [warning, setWarning] = useState({ state: false, count: 0 });
  const [response, setResponse] = useState("");
  const [errorState, setErrorState] = useState({
    name: "",
    email: "",
  });
  const [modalState, setModalState] = useState("");
  const [loader, setLoader] = useState(false);
  const [width, setWidth] = useState(window?.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  const onFormdataChange = (e) => {
    if (e.target.name === "company") {
      const company = /^[a-zA-Z0-9\s]*$/;
      if (e.target.value !== " " && e.target.value.match(company)) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      }
    } else if (e.target.value !== " ") {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const onPrimaryDetailsChange = (e) => {
    if (e.target.name === "phone") {
      const reg = /^[0-9\s()\-+]*$/;
      if (e.target.value !== " " && e.target.value.match(reg))
        setFormData({
          ...formData,
          primary_member: {
            ...formData.primary_member,
            [e.target.name]: e.target.value,
          },
        });
    } else if (
      e.target.name === "first_name" ||
      e.target.name === "last_name"
    ) {
      const reg = /^[a-zA-Z\s]*$/;
      if (e.target.value !== " " && e.target.value.match(reg))
        setFormData({
          ...formData,
          primary_member: {
            ...formData.primary_member,
            [e.target.name]: e.target.value,
          },
        });
    } else if (e.target.value !== " ") {
      setFormData({
        ...formData,
        primary_member: {
          ...formData.primary_member,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  const countChange = (e) => {
    if (isMemberDetailsChanged) {
      setWarning({ state: true, count: e.target.value });
      return;
    }
    setCount(e.target.value);
    let datas = Array(Number(e.target.value - 1)).fill({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      job_title: "",
    });
    setFormfieds(datas);
  };
  const onConfirm = () => {
    setIsMemberDetailsChanged(false);
    setCount(warning?.count);
    setWarning({ ...warning, state: false });
    let datas = Array(Number(warning?.count - 1)).fill({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      job_title: "",
    });
    setFormfieds(datas);
  };

  const duplicateCheck = (e, value) => {
    let type;
    if (value !== "team_name") {
      type = "email";
    } else {
      type = value;
    }
    axios
      .get(
        `${Config?.apiEndPoint}/account/register/exists?${type}=${e.target.value}`
      )
      .then(function (response) {
        if (value === "team_name") {
          setErrorState({ ...errorState, name: response?.data?.message });
        } else if (value === "email") {
          setErrorState({ ...errorState, email: response?.data?.message });
        } else {
          setErrorState({ ...errorState, [value]: response?.data?.message });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (Object.keys(errorState).find((i) => errorState[i] === true)) {
      setModalState("Warning");
      setopenSubmitModal(true);
      return;
    }
    setLoader(true);
    const body = {
      params: {
        company: formData?.company,
        team_name: formData?.team_name,
        country: formData?.country,
        team_size: Number(count),
        primary_member: {
          first_name: formData?.primary_member?.first_name,
          last_name: formData?.primary_member?.last_name,
          email: formData?.primary_member?.email,
          phone: formData?.primary_member?.phone,
          job_title: formData?.primary_member?.job_title,
        },
        members: formFileds,
      },
    };
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.withCredentials = false;
    axios
      .post(`${Config?.apiEndPoint}/account/register`, body)
      .then(function (response) {
        setLoader(false);
        setModalState("Success");
        setopenSubmitModal(true);
        setResponse(response?.data?.message);
        setFormfieds([]);
        setCount(1);
        setFormData();
      })
      .catch(function (error) {
        setLoader(false);
        setopenSubmitModal(true);
        setModalState("Error");
        setResponse(error?.response?.data?.message);
      });
  };
  const checkboxChange = () => {
    setChecked(!checked);
  };

  const handleChange = (e, id) => {
    //  if(e.target.name==="phone"){
    //   const reg = /^[0-9\s()\-+]*$/;
    //  if (e.target.value===""||e.target.value.match(reg)){

    //  }}
    if (e.target.name === "phone") {
      const reg = /^[0-9\s()\-+]*$/;
      if (e.target.value !== " " && e.target.value.match(reg)) {
        const data = formFileds?.map((item, index) => {
          return id === index
            ? { ...item, [e.target.name]: e.target.value }
            : { ...item };
        });
        setFormfieds(data);
      }
    } else if (
      e.target.name === "first_name" ||
      e.target.name === "last_name"
    ) {
      const reg = /^[a-zA-Z\s]*$/;
      if (e.target.value !== " " && e.target.value.match(reg)) {
        const data = formFileds?.map((item, index) => {
          return id === index
            ? { ...item, [e.target.name]: e.target.value }
            : { ...item };
        });
        setFormfieds(data);
      }
    } else {
      const data = formFileds?.map((item, index) => {
        return id === index
          ? { ...item, [e.target.name]: e.target.value }
          : { ...item };
      });
      setFormfieds(data);
    }
  };

  useEffect(() => {
    setIsMemberDetailsChanged(
      !formFileds.every(
        (item) =>
          item?.first_name?.length === 0 &&
          item?.last_name?.length === 0 &&
          item?.email?.length === 0 &&
          item?.phone?.length === 0 &&
          item?.job_title?.length === 0
      )
    );
  }, [formFileds, count]);

  const onWarningSubmit = () => {
    setopenSubmitModal(false);
    setLoader(true);
    const body = {
      params: {
        company: formData?.company,
        team_name: formData?.team_name,
        country: formData.country,
        team_size: Number(count),
        primary_member: {
          first_name: formData?.primary_member?.first_name,
          last_name: formData?.primary_member?.last_name,
          email: formData?.primary_member?.email,
          phone: formData?.primary_member?.phone,
          job_title: formData?.primary_member?.job_title,
        },
        members: formFileds,
      },
    };
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.withCredentials = false;
    axios
      .post(`${Config?.apiEndPoint}/account/register`, body)
      .then(function (response) {
        setLoader(false);
        setopenSubmitModal(true);
        setResponse(response?.data?.message);
        setModalState("Success");
        setFormfieds([]);
        setCount(1);
        setFormData({
          company: "",
          team_name: "",
          country: "",
          team_size: 1,
          primary_member: {
            first_name: "",
            last_name: "",
            email: "",
            job_title: "",
            phone: "",
          },
        });
      })
      .catch(function (error) {
        setLoader(false);
        setopenSubmitModal(true);
        setModalState("Error");
        setResponse(error?.response?.data?.message);
      });
  };
  const handleClose = () => {
    if (modalState === "Error") {
      setopenSubmitModal(false);
      setModalState("");
      return;
    }
    setopenSubmitModal(false);
    setFormfieds([]);
    setCount(1);
    setFormData({
      company: "",
      team_name: "",
      country: "",
      team_size: 1,
      primary_member: {
        first_name: "",
        last_name: "",
        email: "",
        job_title: "",
        phone: "",
      },
    });
    setErrorState({
      name: "",
      email: "",
    });
    window.location.href = "https://www.engagedigital.ai";
    setModalState("");
  };

  return (
    <>
      {loader && (
        <Modal show={loader} className="modal1">
          <Spinner
            animation="border"
            variant="primary"
            className="spinnerStyle"
          />
        </Modal>
      )}
      <div className="formdiv">
        <Container lg={12} className="w-100  mt-3 mr-3 p-0">
          <h4 className="formtitle">
            Please register yourself and your team members for Engage Digital
            Account
          </h4>
          <Form
            onSubmit={(e) => handleSubmit(e)}
            className="form"
            data-testid="form"
          >
            <Row lg={12} className="pb-3">
              <Col lg={12} className="firstcolumnStyle">
                <Form.Group className="" controlId="formBasicEmail">
                  <Form.Text className="fontStyle">TEAM NAME*</Form.Text>
                  <Form.Control
                    className="fontStyle"
                    type="text"
                    // placeholder="TEAM NAME*"
                    size="lg"
                    name="team_name"
                    style={{ borderColor: errorState.name ? "#DC1C4C" : null }}
                    value={formData?.team_name || ""}
                    onChange={(e) => onFormdataChange(e)}
                    onBlur={(e) => duplicateCheck(e, "team_name")}
                    required
                  />
                  {/* <span>abcd</span> */}
                  {errorState.name && (
                    <Form.Text style={{ fontSize: "14px", color: "#DC1C4C" }}>
                      Team Name is registered in the system
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col lg={12} className="firstcolumnStyle">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Text className="fontStyle">
                    COMPANY/ORGANIZATION*
                  </Form.Text>
                  <Form.Control
                    className="fontStyle"
                    type="text"
                    // placeholder="COMPANY*"
                    size="lg"
                    name="company"
                    value={formData?.company}
                    onChange={(e) => onFormdataChange(e)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col lg={12} className="countrycolumnStyle">
                {" "}
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Text className="fontStyle">COUNTRY*</Form.Text>
                  <Form.Select
                    className="fontStyle"
                    type="text"
                    // placeholder="COUNTRY*"
                    size="lg"
                    name="country"
                    value={formData?.country || " "}
                    onChange={(e) => onFormdataChange(e)}
                    required
                  >
                    <option selected></option>
                    {CountryList?.map((country, id) => (
                      <option
                        key={id}
                        value={country?.name}
                        style={{ maxWidth: "90%" }}
                      >
                        {country?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={12} className="selectteamStyle">
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Text className="fontStyle">SELECT TEAM SIZE*</Form.Text>
                  <Form.Select
                    type="text"
                    as="select"
                    // placeholder="SELECT TEAM SIZE*"
                    name="teamSize"
                    size="lg"
                    value={count}
                    onChange={(e) => countChange(e)}
                    required
                    className="fontStyle"
                  >
                    {options.map((item, id) => (
                      <option key={id} value={item}>
                        {item}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row
              lg={12}
              style={{ background: "#CED4DA ", borderRadius: "3px" }}
              className="pt-1 pb-1 mt-1 mb-3 pl-0"
            >
              <h5 className="leadtitle">Primary Contact Details</h5>
            </Row>
            <Row lg={12}>
              <Col style={{ width: "4.16%" }} className="p-2">
                <div
                  style={{
                    backgroundColor: "#CED4DA",
                    width: "100%",
                    height: "45px",
                    borderRadius: "3px",
                    marginTop: "30px",
                    textAlign: "center",
                  }}
                >
                  <h3 className="numberText">1</h3>
                </div>
              </Col>
              <Col className="columnStyle" lg={12}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Text className="fontStyle">FIRST NAME*</Form.Text>
                  <Form.Control
                    className="fontStyle"
                    size="lg"
                    type="text"
                    // placeholder="FIRST NAME*"
                    name="first_name"
                    value={formData?.primary_member?.first_name}
                    onChange={(e) => onPrimaryDetailsChange(e)}
                    required
                  />
                  {/* <Form.Error className="text-muted">
                  We'll never share your email with anyone else.
                </Form.Text> */}
                </Form.Group>
              </Col>
              <Col className="columnStyle" lg={12}>
                {" "}
                <Form.Group
                  className="mb-3"
                  controlId="formBasicPassword"
                  size="lg"
                >
                  <Form.Text className="fontStyle">LAST NAME*</Form.Text>
                  <Form.Control
                    className="fontStyle"
                    size="lg"
                    type="text"
                    // placeholder="LAST NAME*"
                    name="last_name"
                    value={formData?.primary_member?.last_name}
                    onChange={(e) => onPrimaryDetailsChange(e)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col className="columnStyle" lg={12}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Text className="fontStyle">EMAIL ID*</Form.Text>
                  <Form.Control
                    className="fontStyle"
                    type="email"
                    // placeholder="EMAIL ID*"
                    inputprops={{ required: true }}
                    size="lg"
                    name="email"
                    style={{ borderColor: errorState.email ? "#DC1C4C" : null }}
                    value={formData?.primary_member?.email}
                    onBlur={(e) => duplicateCheck(e, "email")}
                    onChange={(e) => onPrimaryDetailsChange(e)}
                    required
                  />
                  {errorState.email && (
                    <Form.Text style={{ fontSize: "14px", color: "#DC1C4C" }}>
                      Email ID is registered in the system
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col className="columnStyle" lg={12}>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Text className="fontStyle">PHONE</Form.Text>
                  <Form.Control
                    type="text"
                    // placeholder="PHONE"
                    size="lg"
                    maxLength={20}
                    className="fontStyle"
                    name="phone"
                    value={formData?.primary_member?.phone}
                    onChange={(e) => onPrimaryDetailsChange(e)}
                  />
                </Form.Group>
              </Col>
              <Col className="columnStyle" lg={12}>
                {" "}
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Text className="fontStyle">JOB TITLE</Form.Text>
                  <Form.Control
                    type="text"
                    // placeholder="JOB TITLE"
                    size="lg"
                    name="job_title"
                    value={formData?.primary_member?.job_title}
                    onChange={(e) => onPrimaryDetailsChange(e)}
                    className="fontStyle"
                  />
                </Form.Group>
              </Col>
            </Row>

            {count > 1 && (
              <>
                <Row
                  lg={12}
                  style={{ background: "#CED4DA ", borderRadius: "3px" }}
                  className="pt-1 pb-1 mt-1 mb-3"
                >
                  <h3 className="leadtitle">Member Contact Details</h3>
                </Row>
                {formFileds?.map((item, id) => {
                  return (
                    <Row key={id} lg={12}>
                      <Col style={{ width: "4.16%" }} className="p-1 ">
                        <div
                          style={{
                            backgroundColor: "#CED4DA",
                            width: "100%",
                            height: "45px",
                            borderRadius: "3px",
                            textAlign: "center",
                            marginTop: id === 0 ? "34px" : "0px",
                          }}
                        >
                          <h3 className="numberText">{id + 2}</h3>
                        </div>
                      </Col>
                      <Col className="columnStyle" lg={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          {(id === 0 || width < 1000) && (
                            <Form.Text className="fontStyle">
                              FIRST NAME*
                            </Form.Text>
                          )}
                          <Form.Control
                            className="fontStyle"
                            type="text"
                            name="first_name"
                            value={item?.first_name || ""}
                            onChange={(e) => handleChange(e, id)}
                            // placeholder="FIRST NAME*"
                            size="lg"
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col className="columnStyle" lg={12} xs={12}>
                        {" "}
                        <Form.Group
                          className="mb-3"
                          controlId="formBasicPassword"
                        >
                          {(id === 0 || width < 1000) && (
                            <Form.Text className="fontStyle">
                              LAST NAME*
                            </Form.Text>
                          )}
                          <Form.Control
                            className="fontStyle"
                            type="text"
                            // name={Object.keys(item)[1]}
                            // value={Object.values(item)[1]}
                            name="last_name"
                            value={item?.last_name || ""}
                            onChange={(e) => handleChange(e, id)}
                            // placeholder="LAST NAME*"
                            size="lg"
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col className="columnStyle" lg={12}>
                        {" "}
                        <Form.Group
                          className="mb-3"
                          controlId="formBasicPassword"
                        >
                          {(id === 0 || width < 1000) && (
                            <Form.Text className="fontStyle">
                              EMAIL ID*
                            </Form.Text>
                          )}
                          <Form.Control
                            className="fontStyle"
                            type="email"
                            name="email"
                            style={{
                              borderColor: errorState[`email` + id]
                                ? "#DC1C4C"
                                : null,
                            }}
                            value={item?.email || ""}
                            onChange={(e) => handleChange(e, id)}
                            onBlur={(e) =>
                              duplicateCheck(e, e?.target?.name + id)
                            }
                            // placeholder="EMAIL ID*"
                            size="lg"
                            required
                          />
                          {errorState[`email` + id] && (
                            <Form.Text
                              style={{ fontSize: "14px", color: "#DC1C4C" }}
                            >
                              Email ID is registered in the system
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col className="columnStyle" lg={12}>
                        {" "}
                        <Form.Group
                          className="mb-3"
                          controlId="formBasicPassword"
                        >
                          {(id === 0 || width < 1000) && (
                            <Form.Text className="fontStyle">PHONE</Form.Text>
                          )}
                          <Form.Control
                            className="fontStyle"
                            type="text"
                            // name={Object.keys(item)[1]}
                            // value={Object.values(item)[1]}
                            name="phone"
                            maxLength={20}
                            value={item?.phone || ""}
                            onChange={(e) => handleChange(e, id)}
                            // placeholder="PHONE*"
                            size="lg"
                          />
                        </Form.Group>
                      </Col>
                      <Col className="columnStyle" lg={12}>
                        {" "}
                        <Form.Group
                          className="mb-3"
                          controlId="formBasicPassword"
                        >
                          {(id === 0 || width < 1000) && (
                            <Form.Text className="fontStyle">
                              JOB TITLE
                            </Form.Text>
                          )}
                          <Form.Control
                            className="fontStyle"
                            type="text"
                            // name={Object.keys(item)[1]}
                            // value={Object.values(item)[1]}
                            name="job_title"
                            value={item?.job_title || ""}
                            onChange={(e) => handleChange(e, id)}
                            // placeholder="JOB TITLE"
                            size="lg"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  );
                })}
                {/* {fieldSelect(10)} */}
                <hr
                  style={{
                    border: "1px solid #707070",
                    margin: "10px 0px 10px 0px",
                  }}
                />
              </>
            )}
            <Row lg={12} style={{ marginTop: "20px", marginBottom: "25px" }}>
              <Col lg={12} className="mt-10">
                {/* <h5 className="noteText">
                <b>Note</b> : Upon completing registration, an Engage Digital
                Account will be created for the Team and user-accounts will be
                created for all team members
              </h5> */}
              </Col>
            </Row>
            <Row lg={12} style={{ marginTop: "20px", marginBottom: "25px" }}>
              <Col lg={12} className="mt-10">
                {" "}
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Form.Check
                    // size={}
                    name="checkbox"
                    checked={checked}
                    onChange={checkboxChange}
                    className="checkboxStyle"
                    color="#334B9D"
                    type="checkbox"
                    id={`default-checkbox`}
                    // label={`I agree to Consent Agreement and Privacy Policy of Radisys Corporation. By supplying my contact information, I authorize Radisys to contact me via personalized communications about Radisys' products and services.`}
                  />
                  <h5 className="checkboxText">
                    By clicking on SUBMIT you accept the Radisys{" "}
                    <a
                      href={
                        configData && configData.terms_of_service
                          ? configData.terms_of_service
                          : Config?.TermsofService
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "#334B9D" }}
                    >
                      Terms and Conditions
                    </a>{" "}
                    and have read the Radisys{" "}
                    <a
                      href={
                        configData && configData.privacy_policy
                          ? configData.privacy_policy
                          : Config.privacyPolicy
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "#334B9D" }}
                    >
                      Privacy Policy.
                    </a>{" "}
                    By supplying my contact information, I authorize Radisys to
                    contact me via personalized communications about Radisys'
                    products and services.
                  </h5>
                </div>
              </Col>
            </Row>
            <Button type="submit" className="submitButton" disabled={!checked}>
              SUBMIT
            </Button>
          </Form>
        </Container>
        <WarningModal
          warning={warning}
          setWarning={setWarning}
          setIsMemberDetailsChanged={setIsMemberDetailsChanged}
          onConfirm={onConfirm}
          count={count}
        />
        <SubmitModal
          openSubmitModal={openSubmitModal}
          setopenSubmitModal={setopenSubmitModal}
          modalState={modalState}
          onWarningSubmit={onWarningSubmit}
          handleClose={handleClose}
          response={response}
          setResponse={setResponse}
        />
      </div>
    </>
  );
}

export default RegForm;
